import React from 'react';
import { ADDITIONAL_PLAYERS_COUNT } from 'constants/tournaments';
import { getEventExperience } from 'utils/shared/events/getEventExperience';
import { getProfileImageUrlOrPlaceholder } from 'utils/shared/user/getProfileImageUrlOrPlaceholder';
import { useAuthModals } from 'hooks/useAuthModals';
import { useViewer } from 'hooks/useViewer';
import CloseIcon from 'svg/CloseIcon';
import { Button } from 'components/Button/Button';
import Modal, { useModal } from 'components/modals/Modal';
import ModalPlayers from 'components/modals/ModalPlayers';
import { EventProps } from './types';

const MAX_REGISTRANTS_DISPLAYED = 8;

export default function Players({ event }: EventProps) {
  const { isUserSession, isSessionLoading } = useViewer();
  const { openSignupModal, ModalSignup, ModalLogin } = useAuthModals();
  const {
    isOpen: isPlayersModalOpen,
    openModal: openPlayersModal,
    closeModal: closePlayersModal,
  } = useModal();

  if (!event) {
    return null;
  }

  const registrationCount = event.isExternal
    ? event.sourceRegistrationCount || 0
    : event?.registrationsAggregate?.aggregate?.count || 0;
  const displayedRegistrationCount = !event.isExternal
    ? /**
       * @todo remove this hack
       */
      registrationCount + ADDITIONAL_PLAYERS_COUNT
    : registrationCount;

  return (
    <>
      <div className="flex flex-col gap-8">
        <h2 className="typography-product-heading-compact text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
          Players going {displayedRegistrationCount}
        </h2>
        {isSessionLoading ? null : isUserSession ? (
          !event.isExternal &&
          registrationCount > 0 && (
            <>
              <div className="grid gap-4 xs:grid-cols-5 md:grid-cols-8">
                {event.registrations.slice(0, MAX_REGISTRANTS_DISPLAYED).map((r) => (
                  <div key={r.id} className="overflow-hidden">
                    <div className="flex flex-col items-center justify-center gap-3">
                      <img
                        src={getProfileImageUrlOrPlaceholder({
                          path: r.userProfile?.profileImagePath,
                        })}
                        alt={`Player ${r.userProfile?.fullName}`}
                        className="object-fit h-12 w-12 rounded-full object-center"
                      />
                      <p className="typography-product-text-card mb-0 text-center text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
                        {r.userProfile?.fullName || 'Going'}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="flex items-center justify-start">
                <Button
                  onClick={() => openPlayersModal()}
                  className="xs:w-full md:w-52"
                  size="md"
                  variant="secondary"
                >
                  View all players
                </Button>
              </div>
            </>
          )
        ) : (
          <div className="mt-4 rounded-md border bg-gray-100 p-8 text-center">
            <p className="mb-4">
              Create a Bounce account to view {getEventExperience(event).noun} players
            </p>
            <Button variant="brand" size="sm" isInline onClick={() => openSignupModal()}>
              Sign up for Bounce
            </Button>
          </div>
        )}
      </div>
      <ModalLogin isShowSignupLink />
      <ModalSignup isShowLoginLink />
      <ModalPlayers
        isOpen={isPlayersModalOpen}
        closeModal={closePlayersModal}
        title="Players"
        event={event}
      />
    </>
  );
}
